import * as yup from 'yup';

import { GenderOptions } from '../types/program';
import { baseImageFieldSchema } from './imageSchema';

const REQUIRED_MESSAGE = 'Por favor, preencha este campo';

const createGenderBasedSchema = (
  requiredMessage: string,
  genderValue: GenderOptions
) =>
  baseImageFieldSchema.shape({
    preview: yup.mixed().when('$gender', ([gender], schema) => {
      return gender?.includes(genderValue)
        ? schema.concat(yup.string().required(requiredMessage))
        : schema;
    }),
  });

const createQuizGenderBasedSchema = (
  requiredMessage: string,
  genderValue: GenderOptions
) =>
  baseImageFieldSchema.shape({
    preview: yup
      .mixed()
      .when(
        ['$gender', '$isRecommendQuiz'],
        ([gender, isRecommendQuiz], schema) => {
          return isRecommendQuiz && gender?.includes(genderValue)
            ? schema.concat(yup.string().required(requiredMessage))
            : schema;
        }
      ),
  });

export const visualStepSchema = yup.object({
  thumb: yup.object({
    web: yup.object({
      neutral: createGenderBasedSchema(
        'Imagem neutra obrigatória',
        GenderOptions.Neutral
      ),
      female: createGenderBasedSchema(
        'Imagem feminina obrigatória',
        GenderOptions.Female
      ),
      male: createGenderBasedSchema(
        'Imagem masculina obrigatória',
        GenderOptions.Male
      ),
    }),
    mobile: yup.object({
      neutral: createGenderBasedSchema(
        'Imagem neutra obrigatória',
        GenderOptions.Neutral
      ),
      female: createGenderBasedSchema(
        'Imagem feminina obrigatória',
        GenderOptions.Female
      ),
      male: createGenderBasedSchema(
        'Imagem masculina obrigatória',
        GenderOptions.Male
      ),
    }),
    tv: yup.object({
      neutral: createGenderBasedSchema(
        'Imagem neutra obrigatória',
        GenderOptions.Neutral
      ),
      female: createGenderBasedSchema(
        'Imagem feminina obrigatória',
        GenderOptions.Female
      ),
      male: createGenderBasedSchema(
        'Imagem masculina obrigatória',
        GenderOptions.Male
      ),
    }),
  }),
  teaser: yup.string().nullable(),
  logotipo: yup.object({
    neutral: createGenderBasedSchema(
      'Imagem neutra obrigatória',
      GenderOptions.Neutral
    ),
    female: createGenderBasedSchema(
      'Imagem feminina obrigatória',
      GenderOptions.Female
    ),
    male: createGenderBasedSchema(
      'Imagem masculina obrigatória',
      GenderOptions.Male
    ),
  }),
  bannerInterno: yup.object({
    web: yup.object({
      neutral: createGenderBasedSchema(
        'Imagem neutra obrigatória',
        GenderOptions.Neutral
      ),
      female: createGenderBasedSchema(
        'Imagem feminina obrigatória',
        GenderOptions.Female
      ),
      male: createGenderBasedSchema(
        'Imagem masculina obrigatória',
        GenderOptions.Male
      ),
    }),
    tv: yup.object({
      neutral: createGenderBasedSchema(
        'Imagem neutra obrigatória',
        GenderOptions.Neutral
      ),
      female: createGenderBasedSchema(
        'Imagem feminina obrigatória',
        GenderOptions.Female
      ),
      male: createGenderBasedSchema(
        'Imagem masculina obrigatória',
        GenderOptions.Male
      ),
    }),
    mobileApp: yup.object({
      neutral: createGenderBasedSchema(
        'Imagem neutra obrigatória',
        GenderOptions.Neutral
      ),
      female: createGenderBasedSchema(
        'Imagem feminina obrigatória',
        GenderOptions.Female
      ),
      male: createGenderBasedSchema(
        'Imagem masculina obrigatória',
        GenderOptions.Male
      ),
    }),
    tablet: yup.object({
      neutral: createGenderBasedSchema(
        'Imagem neutra obrigatória',
        GenderOptions.Neutral
      ),
      female: createGenderBasedSchema(
        'Imagem feminina obrigatória',
        GenderOptions.Female
      ),
      male: createGenderBasedSchema(
        'Imagem masculina obrigatória',
        GenderOptions.Male
      ),
    }),
  }),
  bannerQuiz: yup.object({
    web: yup.object({
      neutral: createQuizGenderBasedSchema(
        'Imagem neutra obrigatória',
        GenderOptions.Neutral
      ),
      female: createQuizGenderBasedSchema(
        'Imagem feminina obrigatória',
        GenderOptions.Female
      ),
      male: createQuizGenderBasedSchema(
        'Imagem masculina obrigatória',
        GenderOptions.Male
      ),
    }),
    appResponsive: yup.object({
      neutral: createQuizGenderBasedSchema(
        'Imagem neutra obrigatória',
        GenderOptions.Neutral
      ),
      female: createQuizGenderBasedSchema(
        'Imagem feminina obrigatória',
        GenderOptions.Female
      ),
      male: createQuizGenderBasedSchema(
        'Imagem masculina obrigatória',
        GenderOptions.Male
      ),
    }),
  }),
  whoHelpYou: yup.object({
    name: yup.string().when('activated', ([activated], schema) => {
      return activated === true
        ? schema.concat(yup.string().required(REQUIRED_MESSAGE))
        : schema.concat(yup.string().nullable());
    }),
    description: yup.string().nullable(),
    activated: yup.boolean(),
  }),
  howItWorks: yup.object({
    name: yup.string().when('activated', ([activated], schema) => {
      return activated === true
        ? schema.concat(yup.string().required(REQUIRED_MESSAGE))
        : schema.concat(yup.string().nullable());
    }),
    description: yup.string().when('activated', ([activated], schema) => {
      return activated === true
        ? schema.concat(yup.string().required(REQUIRED_MESSAGE))
        : schema.concat(yup.string().nullable());
    }),
    activated: yup.boolean().required(REQUIRED_MESSAGE),
  }),
});

export type VisualStepForm = yup.InferType<typeof visualStepSchema>;
